import React, {useState} from 'react'
import { motion } from 'framer-motion';
import Image from 'next/image'
import { dismissModal } from '../../service/modal-service';
import { s3Static } from '../../utils/constants';
import { ZoomableImage } from './ZoomableImage';
import ReactPlayer from 'react-player';

export const ImageModal = (props) => {
    let media = props.media
    let mediaType = props.mediaType
    let imageX = props.imageX
    let imageY = props.imageY

  return (
    <motion.div className="flex justify-center right-0 top-0 fixed z-30 w-full h-full bg-black overflow-y-auto"
        initial = {{
            x : imageX,
            y : imageY,
            scale: 0,
        }}
        animate = {{
            x : 0,
            y: 0,
            scale: 1
        }}
        transition={{
            duration: 0.5,
        }}
        exit = {{
            x : imageX,
            y : imageY,
            scale: 0,
        }}
    >
        <div className='relative h-full w-full'>   
            {mediaType.includes("image") &&
                <ZoomableImage showZoomIndicator={false}>
                    <Image src={media}
                        fill
                        style={{objectFit: 'contain'}}
                        quality={100}
                        placeholder="blur"
                        alt='modal media'
                        blurDataURL={s3Static + "placeholder.png"}
                    />
                </ZoomableImage>
            }
            {mediaType.includes("gif") &&
                <ZoomableImage showZoomIndicator={false}>
                    <Image src={media}
                        fill
                        style={{objectFit: 'contain'}}
                        quality={100}
                        placeholder="blur"
                        alt='modal media'
                        blurDataURL={s3Static + "placeholder.png"}
                    />
                </ZoomableImage>
            }
            {mediaType.includes("video") &&
                <ReactPlayer 
                    src={media} 
                    loop={true}
                    muted={false}
                    playing={true}
                    height="100%"
                    width="100%"
                    controls={true}
                    playsInline={true}
                />
            }
        </div>  
        <div className=''>
            <button type="button" onClick={dismissModal} 
                className="bg-black/60 absolute right-0 m-auto top-0 text-white rounded-lg text-2xl p-1.5 ml-auto items-center">
                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>  
            </button>
        </div> 
    </motion.div>
  )
}
